import request from '@/utils/request.js';

// 用户相关所有请求

export function getFeedbackStatusAPI(fromData) {
  return request({
    url: `/feedback/getFeedbackStatus`,
    method: 'GET',
    params: fromData,
  });
}

export async function updateFeedbackStatusAPI(fromData) {
  return await request({
    url: `/feedback/updateFeedbackStatus`,
    method: 'POST',
    data: fromData,
  });
}

export function getIsFeedbackAPI(fromData) {
  return request({
    url: `/feedback/getIsFeedback`,
    method: 'GET',
    params: fromData,
  });
}

export async function insertFeedbackAPI(fromData) {
  return await request({
    url: `/feedback/insertFeedback`,
    method: 'POST',
    data: fromData,
  });
}
